import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

const STORAGE_KEY = 'redirect_uri';
const ALLOWED_REDIRECT_DOMAINS = ['sascar.com.br', 'sascarapis.com.br'];

@Injectable({ providedIn: 'root' })
export class RedirectUriService {

  private redirectUri: string | null = null;

  constructor() {
    this.initialize();
  }

  private initialize(): void {
    if (typeof globalThis.window === 'undefined') {
      return;
    }

    const params = new URLSearchParams(globalThis.location.search);
    const queryRedirectUri = params.get('redirectUri');

    if (queryRedirectUri) {
      if (this.isAllowed(queryRedirectUri)) {
        this.redirectUri = queryRedirectUri;
        sessionStorage.setItem(STORAGE_KEY, queryRedirectUri);
      }

      params.delete('redirectUri');
      const query = params.toString();
      globalThis.history.replaceState(
        {},
        document.title,
        globalThis.location.pathname + (query ? `?${query}` : ''),
      );
      return;
    }

    const storedRedirectUri = sessionStorage.getItem(STORAGE_KEY);
    if (storedRedirectUri && this.isAllowed(storedRedirectUri)) {
      this.redirectUri = storedRedirectUri;
    }
  }

  private isAllowed(value: string): boolean {
    try {
      const url = new URL(value);

      if (!environment.production && this.isLocalhost(url)) {
        return true;
      }

      if (url.protocol !== 'https:') {
        return false;
      }
      return ALLOWED_REDIRECT_DOMAINS.some(
        (domain) => url.hostname === domain || url.hostname.endsWith(`.${domain}`),
      );
    } catch {
      return false;
    }
  }

  private isLocalhost(url: URL): boolean {
    return (
      (url.protocol === 'http:' || url.protocol === 'https:') &&
      (url.hostname === 'localhost' || url.hostname === '127.0.0.1')
    );
  }

  getRedirectUri(): string {
    return this.redirectUri ?? environment.URL_GESTAO_FROTAS;
  }
}
